import React from "react";

import { Flex, Icon, type FlexProps } from "@chakra-ui/react";

import CloseSvg from "@/assets/svg/close-1.svg";

interface PreferenceButtonProps {
  children: React.ReactNode;
  color: string;
  isClose: boolean;
  isActive: boolean;
  closeHandler: () => void;
  handler?: () => void;
  style?: FlexProps;
}

const PreferenceButton = ({
  children,
  color,
  isClose,
  isActive,
  closeHandler,
  handler,
  style,
}: PreferenceButtonProps) => {
  const onCloseHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    closeHandler();
  };

  return (
    <Flex
      align={"center"}
      px={"12px"}
      columnGap={"12px"}
      bg={isActive ? color : "transparent"}
      _hover={{ bg: "dashboardBackground", color: "mainBlue" }}
      color={isActive ? "mainBlue" : "grey"}
      onClick={handler}
      {...style}
    >
      {children}
      {isClose ? (
        <Icon as={CloseSvg} onClick={onCloseHandler} cursor={"pointer"} />
      ) : null}
    </Flex>
  );
};

export default PreferenceButton;
